import { render } from "./DependentQuestionsPanel.vue?vue&type=template&id=efde3a12"
import script from "./DependentQuestionsPanel.vue?vue&type=script&lang=js"
export * from "./DependentQuestionsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__